export default __webpack_public_path__ + "static/media/step-c-2.637f7b96.png";